import React from 'react';
import Avatar from '@atlaskit/avatar';
import { StyledChild, StyledOption } from '../../../common/ui/styled';
export var AvatarOptionLabel = function AvatarOptionLabel(_ref) {
  var avatarOption = _ref.avatarOption;
  return /*#__PURE__*/React.createElement(StyledOption, null, /*#__PURE__*/React.createElement(Avatar, {
    src: typeof avatarOption.avatar !== 'string' ? undefined : avatarOption.avatar,
    size: "xsmall",
    appearance: typeof avatarOption.square === 'boolean' && avatarOption.square ? 'square' : 'circle'
  }), /*#__PURE__*/React.createElement(StyledChild, null, avatarOption.label));
};